import { render, staticRenderFns } from "./GerenciamentoHome.vue?vue&type=template&id=5da5a589&"
import script from "./GerenciamentoHome.vue?vue&type=script&lang=js&"
export * from "./GerenciamentoHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports